import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthStore } from "../../core/stores/auth.store";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authStore = inject(AuthStore);
    const idToken = authStore.idToken();

    if (idToken) {
        const clonedRequest = req.clone({
            setHeaders: {
                "id-token": idToken
            }
        });
        return next(clonedRequest);
    }

    return next(req);
};
